/**
 * Maps a privacy request form field onto its key in the `privacyRights` catalog.
 *
 * Separate from the block so it can be asserted against the form JSON without pulling in
 * MUI, Turnstile and the rest of the form's dependencies.
 */
export const FORM_LABEL_KEYS: Record<string, string> = {
  firstName: 'form.firstName',
  lastName: 'form.lastName',
  streetAddress: 'form.streetAddress',
  stateProvince: 'form.stateProvince',
  country: 'form.country',
  email: 'form.email',
  phone: 'form.phone',
  optingOutOrSharing: 'form.optingOutOrSharing',
  privacyRightsRequest: 'form.privacyRightsRequest',
}

/** Same, for the data download form. */
export const DOWNLOAD_LABEL_KEYS: Record<string, string> = {
  firstName: 'download.firstName',
  lastName: 'download.lastName',
  email: 'download.email',
}
